import React, { useState, useEffect, useCallback } from 'react';
import { toast } from 'react-hot-toast';

import { FaMapMarkedAlt } from 'react-icons/fa';
import { DropdownMenu } from 'reactstrap';

import PermissionErrorContainer from '~/components/PermissionErrorContainer';
import { VideoPlayer } from '~/components/VideoPlayer';

import api2 from '~/services/api2';
import { useAuth } from '~/context/AuthContext';
import { PageTitle } from '~/components/PageTitle';
import { Switch } from 'takeat-design-system-ui-kit';
import MapEditor from './MapEditor';
import Neighborhoods from './Neighborhoods';
import MapDistances from './MapDistances';
import {
  Container,
  Header,
  ConfigButton,
  MenuItem,
  ConfigDropdownToggle,
  Card,
} from './styles';

function DeliveryAddress() {
  const { user, getProfileData } = useAuth();

  const [permission, setPermission] = useState(false);
  const [loadingPage, setLoadingPage] = useState(false);

  const validateUser = useCallback(async () => {
    setLoadingPage(true);
    try {
      const response = await api2.get(
        '/restaurants/users/role-permission/DeliveryAddresses'
      );
      setLoadingPage(false);
      const { can_read } = response.data.DeliveryAddresses;

      setPermission(can_read);
    } catch (error) {
      toast.error('Erro ao solicitar acesso');
      setLoadingPage(false);
    }
  }, []);

  useEffect(() => {
    validateUser();
  }, [validateUser]);

  const [deliveryTypeSwitch, setDeliveryTypeSwitch] = useState(() => {
    const addresses_allowed = user.delivery_info.allow_delivery_addresses;

    let use_address = false;
    let use_distance = false;
    let use_map = false;

    if (user.delivery_info.delimit_by_area) {
      use_map = true;
    } else if (user.delivery_info.is_delivery_by_distance) {
      use_distance = true;
    } else {
      use_address = true;
    }

    return {
      use_address,
      use_distance,
      use_map,
      addresses_allowed,
    };
  });

  const [isTypeChanging, setIsTypeChanging] = useState(false);

  async function deliveryTypeChange(id) {
    const data = { ...deliveryTypeSwitch };

    switch (id) {
      case 'address':
        data.use_distance = false;
        data.use_address = true;
        data.use_map = false;
        break;
      case 'distance':
        data.use_distance = true;
        data.use_address = false;
        data.use_map = false;
        break;
      case 'map':
        data.use_distance = false;
        data.use_address = false;
        data.use_map = true;
        break;
      default:
        break;
    }

    try {
      setIsTypeChanging(true);
      await api2.put('/restaurants/delivery-info', {
        is_delivery_by_distance: data.use_distance,
        delimit_by_area: data.use_map,
      });

      await getProfileData();
      toast.success('Atualizado!');

      setDeliveryTypeSwitch(data);
      setIsTypeChanging(false);
    } catch (e) {
      setIsTypeChanging(false);
      toast.success('Erro ao atualizar!');
    }
  }

  const [onlyAddress, setOnlyAddress] = useState(
    deliveryTypeSwitch.use_address
  );

  function onlyAddressChange() {
    setOnlyAddress(!onlyAddress);

    if (onlyAddress) {
      deliveryTypeChange('distance');
    } else {
      deliveryTypeChange('address');
    }
  }

  return !permission ? (
    <PermissionErrorContainer loading={loadingPage} />
  ) : (
    <Container>
      <Header>
        <h3>Configuração de Locais de Entrega</h3>
        <p>
          Cadastre as áreas onde seu estabelecimento realiza entregas. Você pode
          definir locais por raio, desenhando áreas no mapa ou cadastrando
          manualmente regiões e bairros.
        </p>
      </Header>

      <Card>
        <Switch
          label="Ativar entrega por raio ou área no mapa"
          checked={!onlyAddress}
          onChange={() => {
            onlyAddressChange();
          }}
        />
        {deliveryTypeSwitch.use_distance && (
          <MapDistances
            deliveryTypeChange={deliveryTypeChange}
            isTypeChanging={isTypeChanging}
          />
        )}
        {deliveryTypeSwitch.use_map && (
          <MapEditor
            deliveryTypeChange={deliveryTypeChange}
            isTypeChanging={isTypeChanging}
          />
        )}
      </Card>

      <Neighborhoods />
    </Container>
  );
}

export default DeliveryAddress;
